import React, {useMemo} from 'react';
import { useLocation } from 'react-router-dom';

import NewAppIFrame from 'components/NewAppIFrameViewer';


const UserActions = () => {
  const location = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const defaultSelectedAction = searchParams.get('defaultSelectedAction') || '';


  const iFramePagePath = defaultSelectedAction ? `analytics/user-actions?defaultSelectedAction=${defaultSelectedAction}` : 'analytics/user-actions';
  return (
    <NewAppIFrame
      iFramePagePath={iFramePagePath}
      title="User Actions"
    />
  );
};
export default UserActions;